import { useEffect } from "react";

/**
 * Custom React hook to update the browser tab title.
 * Usage: usePageTitle("Fontene Lunsj – Hovedside");
 */
export default function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
